import { Subscription } from 'rxjs';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { IonHeader, DomController, IonTabBar, IonSegment, NavController } from '@ionic/angular';
import { SeoService } from 'src/app/services/seo.service';
import { ActivatedRoute } from '@angular/router';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { SlugifyPipe } from 'src/app/pipes/slugify.pipe';
import { RetailCartService } from 'src/app/services/retail/retail-cart.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { RetailDetailAPIResponse, TabLabel } from 'src/app/models/product-list';
import { RetailDetailService } from 'src/app/services/retail/retail-detail.service';
@Component({
  selector: 'app-retail-detail',
  templateUrl: './retail-detail.page.html',
  styleUrls: ['./retail-detail.page.scss'],
})
export class RetailDetailPage implements OnInit {
  private TabLabel = TabLabel;
  private tabType = TabLabel.ABOUT;
  imagePlaceholder = 'assets/icons/trvlx128.png';
  private currencyCode: string;
  isAsp: boolean;
  locationId: any;
  storeId: any;
  query: string;
  storeInfo: RetailDetailAPIResponse;
  pageTitle: string;
  showQuantButton: number;
  totalQuantity: number;
  totalPrice: number;
  pageNo: number;
  noData: number;
  productsList: any[];
  constructor(
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute,
    private i18ConfigService: I18ConfigService,
    private retailDetailService: RetailDetailService,
    private cartService: CartService,
    private loaderService: LoaderService,
    private retailCartService: RetailCartService,
    private slugifyPipe: SlugifyPipe,
    private navControl: NavController,
  ) {

    this.currencyCode = i18ConfigService.getCurrency();

  }
  ngOnInit(): void {

  }

  async ionViewDidEnter() {
    this.isAsp = false;
    if (localStorage.getItem('pid') === 'asp') {
      this.isAsp = true;
    }
    this.locationId = this.activatedRoute.snapshot.params.loc;
    this.storeId = this.activatedRoute.snapshot.params.storeId;
    this.query = this.activatedRoute.snapshot.queryParamMap.get('q');
    // this.storeName = this.activatedRoute.snapshot.params.storeName;
    // this.seoService.updatePageTitle(this.storeInfo.storeName + 'productlist');
    this.showQuantButton = 0;
    this.totalQuantity = 0;
    this.totalPrice = 0;
    this.initPageState();
    await this.loaderService.presentLoading('Loading...');
    if (this.locationId && this.storeId) {
      this.retailDetailService.getRetailerDetailsByStoreId(this.storeId, 1, this.locationId, '').subscribe(async (response: RetailDetailAPIResponse) => {
        this.updatePageState(response);
        await this.loaderService.loading.dismiss();
      });
    } else {
      // declare incomplete/incorrect request
    }
  }

  initPageState(): void {
    this.pageTitle = '';
    this.noData = 0;
    this.productsList = [];
    this.storeInfo = {} as RetailDetailAPIResponse;
  }

  updatePageState(retailResp: RetailDetailAPIResponse) {
    if (!retailResp || !retailResp.id) {
      this.noData = 1;
      return;
    }
    this.storeInfo = retailResp;
    // this.tabType = this.storeInfo.tabs[0].type;
    this.pageTitle = this.storeInfo.storeName;
  }

  viewMoreProducts() {
    this.navControl.navigateForward(['shopping/retail/products/', this.slugifyPipe.transform(this.storeInfo.storeName), this.storeInfo.id, { loc: this.locationId }]);
  }

}
